import Client from "./Clients/AxiosClient";
const resource = "/api/v1/admin/soals";

export default {
  get(payload) {
    const params = {
      page: payload.page || 1,
      page_size: payload.page_size || 10,
      search: payload.search || "",
    };

    const filters = [];

    if (payload.mata_pelajaran) {
      filters.push(`mata_pelajaran:${payload.mata_pelajaran}`);
    }

    if (payload.kategori) {
      filters.push(`kategori_soal:${payload.kategori}`);
    }

    if (payload.paket) {
      filters.push(`paket:${payload.paket}`);
    }

    if (filters.length > 0) {
      params.filters = filters.join(",");
    }

    return Client.get(resource, { params });
  },
  show(id) {
    return Client.get(`${resource}/${id}`);
  },
  create(payload) {
    return Client.post(`${resource}`, payload);
  },
  update(payload, id) {
    return Client.put(`${resource}/${id}`, payload);
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`);
  },
  importExcel(payload) {
    return Client.post(`${resource}/import-excel`, payload);
  },
};
